webpackJsonp([36],{

/***/ 1195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ajax = __webpack_require__(1441);

var _ajax2 = _interopRequireDefault(_ajax);

var _auth = __webpack_require__(1191);

var _auth2 = _interopRequireDefault(_auth);

var _carousels = __webpack_require__(1442);

var _carousels2 = _interopRequireDefault(_carousels);

var _events = __webpack_require__(939);

var _events2 = _interopRequireDefault(_events);

var _fancybox = __webpack_require__(1443);

var _fancybox2 = _interopRequireDefault(_fancybox);

var _flagListing = __webpack_require__(1444);

var _flagListing2 = _interopRequireDefault(_flagListing);

var _gusTips = __webpack_require__(1196);

var _gusTips2 = _interopRequireDefault(_gusTips);

var _textUtilities = __webpack_require__(1445);

var _textUtilities2 = _interopRequireDefault(_textUtilities);

var _validation = __webpack_require__(1197);

var _validation2 = _interopRequireDefault(_validation);

var _console = __webpack_require__(1446);

var _console2 = _interopRequireDefault(_console);

var _jqueryFixes = __webpack_require__(1447);

var _jqueryFixes2 = _interopRequireDefault(_jqueryFixes);

var _AloomaInitializer = __webpack_require__(1448);

var _AloomaInitializer2 = _interopRequireDefault(_AloomaInitializer);

var _buttons = __webpack_require__(1466);

var _buttons2 = _interopRequireDefault(_buttons);

var _galleries = __webpack_require__(1468);

var _galleries2 = _interopRequireDefault(_galleries);

var _modals = __webpack_require__(1199);

var _modals2 = _interopRequireDefault(_modals);

var _Authenticated = __webpack_require__(1189);

var _Authenticated2 = _interopRequireDefault(_Authenticated);

var _email_capture_footer_form = __webpack_require__(1469);

var _email_capture_footer_form2 = _interopRequireDefault(_email_capture_footer_form);

var _InternalReferrer = __webpack_require__(1200);

var _InternalReferrer2 = _interopRequireDefault(_InternalReferrer);

var _AppInstallBanner = __webpack_require__(1470);

var _AppInstallBanner2 = _interopRequireDefault(_AppInstallBanner);

var _ZendeskHelp = __webpack_require__(1472);

var _ZendeskHelp2 = _interopRequireDefault(_ZendeskHelp);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This stays outside the IIFE since it needs to
// fire events before Vue components are loaded

(0, _jquery2.default)(function () {
  _InternalReferrer2.default.init();
  _ajax2.default.init();
  _email_capture_footer_form2.default.init();
  _AppInstallBanner2.default.init();
  _ZendeskHelp2.default.init();

  _auth2.default.init();
  _buttons2.default.init();
  _carousels2.default.init();
  _events2.default.init();
  _fancybox2.default.init();
  _flagListing2.default.init();
  _gusTips2.default.init();
  _modals2.default.init();
  _textUtilities2.default.init();
  _validation2.default.init();
  _console2.default.init();
  _galleries2.default.init();
  _jqueryFixes2.default.init();
  _Authenticated2.default.init();
  _AloomaInitializer2.default.init();
});

/***/ }),

/***/ 1196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init() {
  var $gusTips = (0, _jquery2.default)('.js-gus-tip');
  $gusTips.each(function () {
    var $this = (0, _jquery2.default)(this);
    var shouldShow = _jquery2.default.cookie($this.data('gus-tip-cookie')) !== 'dismissed';
    if (shouldShow) {
      $this.show();
    }
  });
}

function handleGusTipDismiss() {
  var $gusTip = (0, _jquery2.default)(this).closest('.js-gus-tip');
  _jquery2.default.cookie($gusTip.data('gus-tip-cookie'), 'dismissed', { expires: 180 });
  $gusTip.hide();
}

exports.default = {
  init: init,
  handleGusTipDismiss: handleGusTipDismiss
};

/***/ }),

/***/ 1198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
window.alooma = window.alooma || {};
exports.default = window.alooma;

/***/ }),

/***/ 1199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Rover = __webpack_require__(7);

var _Rover2 = _interopRequireDefault(_Rover);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _rover_modal = __webpack_require__(228);

var _rover_modal2 = _interopRequireDefault(_rover_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function showModal() {
  var options = {
    content: (0, _jquery2.default)((0, _jquery2.default)(this).attr('data-target')).html(),
    title: (0, _jquery2.default)(this).attr('data-title'),
    disableCancel: (0, _jquery2.default)(this).attr('data-modal-blocking'),
    padding: !((0, _jquery2.default)(this).attr('data-modal-padding') === 'false')
  };

  var modal = new _rover_modal2.default(options);

  modal.open();
}

function initializeBlockingModal() {
  if (_Rover2.default.disable_blocking_modal) return;
  if ((0, _jquery2.default)(document.body).hasClass('js-disable-blocking-modal')) return;

  _Rover2.default.blocking_modals.handleBlockingModal();
}

function init() {
  initializeBlockingModal();
}

exports.default = {
  init: init,
  showModal: showModal,
  initializeBlockingModal: initializeBlockingModal
};

/***/ }),

/***/ 1200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookie = __webpack_require__(627);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  _createClass(_class, null, [{
    key: 'init',
    value: function init() {
      this.setEntryPageCookie();
      this.setUtmCookies();
    }
  }, {
    key: 'getUrlParam',
    value: function getUrlParam(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
    }
  }, {
    key: 'getUrlLocation',
    value: function getUrlLocation() {
      return escape(window.location.pathname);
    }
  }, {
    key: 'setEntryPageCookie',
    value: function setEntryPageCookie() {
      if (!(0, _cookie.hasCookie)('entry_page')) {
        (0, _cookie.createCookie)('entry_page', this.getUrlLocation(), 999999);
      }
    }
  }, {
    key: 'setUtmCookies',
    value: function setUtmCookies() {
      var _this = this;

      var utmParams = ['campaign', 'source', 'medium', 'content', 'term'];
      var override = this.getUrlParam('utm_nooverride') !== '1';
      var hasFirstTimestamp = (0, _cookie.hasCookie)('f_iso');
      var timestamp = new Date().toISOString();

      utmParams.forEach(function (param) {
        var utmParam = 'utm_' + param;
        var utmValue = _this.getUrlParam(utmParam);
        if (!utmValue) return;

        if (!hasFirstTimestamp) {
          (0, _cookie.createCookie)('f_' + utmParam, utmValue, 365);
          (0, _cookie.createCookie)('f_iso', timestamp, 365);
        }

        if (!hasFirstTimestamp || override) {
          (0, _cookie.createCookie)('l_' + utmParam, utmValue, 365);
          (0, _cookie.createCookie)('l_iso', timestamp, 365);
        }
      });
    }
  }, {
    key: 'getCookie',
    value: function getCookie(name) {
      return (0, _cookie.getCookie)(name);
    }
  }, {
    key: 'createCookie',
    value: function createCookie(name, value, days) {
      (0, _cookie.createCookie)(name, value, days);
    }
  }, {
    key: 'hasCookie',
    value: function hasCookie(name) {
      return (0, _cookie.hasCookie)(name);
    }
  }]);

  return _class;
}();

exports.default = _class;

/***/ }),

/***/ 1440:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1195);


/***/ }),

/***/ 1441:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _axios = __webpack_require__(40);

var _axios2 = _interopRequireDefault(_axios);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _Rover = __webpack_require__(7);

var _Rover2 = _interopRequireDefault(_Rover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initJQueryHeaders = function initJQueryHeaders() {
  _jquery2.default.ajaxSetup({ headers: _Rover2.default.api.getSourceHeader() });

  (0, _jquery2.default)(document).ajaxSend(function (e, jqxhr, settings) {
    var token = _Rover2.default.utils.getCsrfToken();

    if (!token) return;

    if (window.isRoverURL(settings.url)) {
      jqxhr.setRequestHeader('X-CSRFToken', token);
    }
  });
};

var initAxiosHeaders = function initAxiosHeaders() {
  _axios2.default.interceptors.request.use(function (config) {
    // if we're requesting a rover url
    if (config.url.includes(window.location.host) || config.url.startsWith('/') || config.url.startsWith('./') || config.url.startsWith('../')) {
      var clone = _extends({}, config);
      // clone the config and add our custom headers
      clone.headers.common = _extends({}, config.headers.common, _Rover2.default.api.getSourceHeader());
      var token = _Rover2.default.utils.getCsrfToken();
      if (token) {
        clone.headers.common['X-CSRFToken'] = token;
      }
      return clone;
    }
    // non-rover urls get NOTHING. so as to avoid CORS issues
    return config;
  }, function (error) {
    return Promise.reject(error);
  });
};

function init() {
  initJQueryHeaders();
  initAxiosHeaders();
}

exports.default = {
  init: init
};

/***/ }),

/***/ 1442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init() {
  /**
   * Ajax support for carousel images.
   * Whenever a carousel slides, look for images in the
   * next slide that need to be loaded asynchronously.
   */
  (0, _jquery2.default)(document).on('slide.bs.carousel', '[data-ride="carousel"]', function (e) {
    // Find the images in the the new slide that need loading
    var srcAttrName = 'data-src',
        loadingClass = 'rover-loading',
        $newSlide = (0, _jquery2.default)(e.relatedTarget),
        $imagesToProcess = $newSlide.find('img[' + srcAttrName + ']');

    $imagesToProcess.each(function () {
      // Find the image source that needs to be loaded
      var $img = (0, _jquery2.default)(this),
          newSrc = $img.attr(srcAttrName),
          $tmpImg = (0, _jquery2.default)('<img>');

      // Define behavior for when the image is finished loading
      $tmpImg.load(function () {
        $img.removeAttr(srcAttrName);
        $img.attr('src', newSrc);
        $img.unwrap();
        $newSlide.trigger('loaded');
      });

      // Update UI to reflect loading and start loading image
      $img.wrap('<div class="img-responsive ' + loadingClass + '"></div>');
      $tmpImg.attr('src', newSrc);
    });
  });
}

exports.default = {
  init: init
};

/***/ }),

/***/ 1443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init() {
  if (_jquery2.default.isFunction(_jquery2.default.fancybox)) {
    (0, _jquery2.default)(document).on('click', '.fancybox-close', _jquery2.default.fancybox.close);
  }
}

exports.default = {
  init: init
};

/***/ }),

/***/ 1444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _Alerts = __webpack_require__(93);

var _Alerts2 = _interopRequireDefault(_Alerts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flagFormSubmitSuccess = function flagFormSubmitSuccess(response, status, xhr, $form) {
  $form.closest('.js-feedback-modal').modal('hide');
  _Alerts2.default.showToast({
    severity: 'success',
    message: "Thank you for flagging this. We'll look at it as soon as possible"
  });
  (0, _jquery2.default)(window).scrollTop(0);
};

function init() {
  this.$flagForm = (0, _jquery2.default)('.js-flag-form');
  this.$flagForm.validate({
    rules: {
      comment: {
        required: true,
        minWords: 4
      }
    }
  });
  this.$flagForm.autoDisableAndValidateAjaxForm({
    success: flagFormSubmitSuccess,
    resetForm: true
  });

  if (window.location.hash === '#flag_dialog') {
    (0, _jquery2.default)('.js-flag-button').trigger('click');
  }
}

exports.default = {
  init: init
};

/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getWords(s) {
  var trimmedString = s.replace(/(^\s*)|(\s*$)/gi, '');
  if (trimmedString === '') return [];
  return trimmedString.split(/\s+/);
}

function getWordCount(s) {
  return getWords(s).length;
}

_jquery2.default.fn.wordCount = function wordCount() {
  return getWordCount((0, _jquery2.default)(this).val());
};

function updateWordCount(e) {
  var $el = (0, _jquery2.default)(e.currentTarget);
  var $counter = $el.siblings().find('.js-word-count-input-counter');
  var $text = $el.siblings().find('.js-word-count-input-text');
  var wordCount = getWordCount($el.val());
  var wordsNeeded = void 0;
  var minWords = $el.attr('data-min-words');
  if (minWords) wordsNeeded = minWords - wordCount;
  $counter.html(Math.max(0, wordsNeeded));

  if (!minWords) {
    return;
  }

  if (wordCount === 0) {
    $text.html('words minimum required');
  } else if (wordsNeeded > 0) {
    $counter.addClass('text-danger');
    $text.addClass('text-danger');
    $text.html('more words needed');
  } else {
    $counter.removeClass('text-danger');
    $text.removeClass('text-danger');
    $text.html('<i class="text-primary rover-icon rover-icon-in-check-mark">');
    $counter.html('');
  }
}

function updateCharCount(evt) {
  var $target = (0, _jquery2.default)(evt.target);
  $target.siblings().find('.js-char-count-input-counter').html($target.val().length);
}

function initWordCount() {
  (0, _jquery2.default)('.js-word-count-input').trigger('input');
}

function initCharCount() {
  (0, _jquery2.default)('.js-char-count-input').trigger('input');
}

function init() {
  (0, _jquery2.default)('.js-word-count-input').on('input', updateWordCount);
  (0, _jquery2.default)('.js-char-count-input').on('input', updateCharCount);

  initWordCount();
  initCharCount();
}

exports.default = {
  init: init,
  getWords: getWords,
  getWordCount: getWordCount,
  updateWordCount: updateWordCount,
  updateCharCount: updateCharCount,
  initWordCount: initWordCount,
  initCharCount: initCharCount
};

/***/ }),

/***/ 1446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function init() {
  /**
   * Ensure that window always has the hasOwnProperty method on it, as
   * older versions of IE do not have this, and we are testing for jQuery presence
   * using it.
   */
  window.hasOwnProperty = function (obj) {
    return !!this[obj];
  };

  /**
   * Prevent errors from calls to console.* from browsers that don't support it.
   */
  if (!window.hasOwnProperty('console')) {
    window.console = {
      assert: function assert() {},
      clear: function clear() {},
      count: function count() {},
      debug: function debug() {},
      dir: function dir() {},
      dirxml: function dirxml() {},
      error: function error() {},
      exception: function exception() {},
      group: function group() {},
      groupCollapsed: function groupCollapsed() {},
      groupEnd: function groupEnd() {},
      info: function info() {},
      log: function log() {},
      profile: function profile() {},
      profileEnd: function profileEnd() {},
      table: function table() {},
      time: function time() {},
      timeEnd: function timeEnd() {},
      timeStamp: function timeStamp() {},
      trace: function trace() {},
      warn: function warn() {}
    };
  }
}

exports.default = {
  init: init
};

/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init() {
    /**
     * Fix jQuery show to work better with Bootstrap hidden/hide classes
     * https://github.com/twbs/bootstrap/issues/9237
     */
    var show = _jquery2.default.fn.show;
    _jquery2.default.fn.show = function () {
        this.removeClass('hidden hide');
        return show.call(this);
    };

    /**
     * Recursively strip whitespace between child elements.
     */
    _jquery2.default.fn.removeWhitespace = function () {
        this.contents().filter(function () {
            if (this.nodeType == 3) {
                return !/\S/.test(this.nodeValue);
            } else {
                (0, _jquery2.default)(this).removeWhitespace();
                return false;
            }
        }).remove();
        return this;
    };
}

exports.default = {
    init: init
};

/***/ }),

/***/ 1448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Rover = __webpack_require__(7);

var _Rover2 = _interopRequireDefault(_Rover);

var _alooma = __webpack_require__(1198);

var _alooma2 = _interopRequireDefault(_alooma);

var _aloomaWrapper = __webpack_require__(1449);

var _aloomaWrapper2 = _interopRequireDefault(_aloomaWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Alooma = function () {
  function Alooma() {
    _classCallCheck(this, Alooma);
  }

  _createClass(Alooma, null, [{
    key: 'init',
    value: function init() {
      if (_alooma2.default.set_config) {
        _alooma2.default.set_config({ track_pageview: false });
      }

      var d = new Date();
      _aloomaWrapper2.default.register({ timezone_offset: d.getTimezoneOffset() });

      if (_Rover2.default.alooma && _Rover2.default.alooma.json) {
        _aloomaWrapper2.default.register(_Rover2.default.alooma.json);
      }

      if (_Rover2.default.gtm && _Rover2.default.gtm.pageCategory) {
        _aloomaWrapper2.default.register({ pageCategory: _Rover2.default.gtm.pageCategory });
      } else {
        _aloomaWrapper2.default.register({ pageCategory: 'uncategorized' });
      }

      if (Object.keys(_alooma2.default).length) {
        _aloomaWrapper2.default.aloomaLoaded();
      }
    }
  }]);

  return Alooma;
}();

exports.default = Alooma;


Alooma.init();

/***/ }),

/***/ 1449:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AloomaWrapper = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventEmitter = __webpack_require__(1450);

var _eventEmitter2 = _interopRequireDefault(_eventEmitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// window.alooma is used by external applications (GTM), so don't remove
window.alooma = window.alooma || {};

var AloomaWrapper = function () {
  function AloomaWrapper() {
    _classCallCheck(this, AloomaWrapper);

    this.ALOOMA_LOADED = 'alooma:loaded';
    this.isAloomaLoaded = false;
    this.registry = {};
    this.sequence = 0;
    this.emitter = (0, _eventEmitter2.default)();
    this.alooma = window.alooma;
  }

  _createClass(AloomaWrapper, [{
    key: 'track',
    value: function track(eventName, props, cb) {
      var _this = this;

      return this.waitForAloomaLoaded().then(function () {
        var clone = _extends({}, _this.registry, props, { sequence: _this.sequence });
        _this.sequence += 1;
        _this.alooma.track(eventName, clone, cb);
      });
    }
  }, {
    key: 'register',
    value: function register(dataObj) {
      this.registry = _extends({}, this.registry, dataObj);
    }
  }, {
    key: 'save',
    value: function save(dataObj) {
      var _this2 = this;

      return this.waitForAloomaLoaded().then(function () {
        return _this2.alooma.register(dataObj);
      });
    }
  }, {
    key: 'waitForAloomaLoaded',
    value: function waitForAloomaLoaded() {
      var _this3 = this;

      return new Promise(function (resolve) {
        if (_this3.isAloomaLoaded) return resolve();
        return _this3.emitter.on(_this3.ALOOMA_LOADED, resolve);
      });
    }
  }, {
    key: 'aloomaLoaded',
    value: function aloomaLoaded() {
      if (!this.isAloomaLoaded) {
        this.alooma.track_pageview();
      }

      this.isAloomaLoaded = true;
      this.emitter.emit(this.ALOOMA_LOADED);
    }
  }]);

  return AloomaWrapper;
}();

// window.aloomaWrapper is used by external applications (GTM), so don't remove


window.aloomaWrapper = new AloomaWrapper();
exports.AloomaWrapper = AloomaWrapper;
exports.default = window.aloomaWrapper;

/***/ }),

/***/ 1450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var d        = __webpack_require__(1451)
  , callable = __webpack_require__(1465)

  , apply = Function.prototype.apply, call = Function.prototype.call
  , create = Object.create, defineProperty = Object.defineProperty
  , defineProperties = Object.defineProperties
  , hasOwnProperty = Object.prototype.hasOwnProperty
  , descriptor = { configurable: true, enumerable: false, writable: true }

  , on, once, off, emit, methods, descriptors, base;

on = function (type, listener) {
	var data;

	callable(listener);

	if (!hasOwnProperty.call(this, '__ee__')) {
		data = descriptor.value = create(null);
		defineProperty(this, '__ee__', descriptor);
		descriptor.value = null;
	} else {
		data = this.__ee__;
	}
	if (!data[type]) data[type] = listener;
	else if (typeof data[type] === 'object') data[type].push(listener);
	else data[type] = [data[type], listener];

	return this;
};

once = function (type, listener) {
	var once, self;

	callable(listener);
	self = this;
	on.call(this, type, once = function () {
		off.call(self, type, once);
		apply.call(listener, this, arguments);
	});

	once.__eeOnceListener__ = listener;
	return this;
};

off = function (type, listener) {
	var data, listeners, candidate, i;

	callable(listener);

	if (!hasOwnProperty.call(this, '__ee__')) return this;
	data = this.__ee__;
	if (!data[type]) return this;
	listeners = data[type];

	if (typeof listeners === 'object') {
		for (i = 0; (candidate = listeners[i]); ++i) {
			if ((candidate === listener) ||
					(candidate.__eeOnceListener__ === listener)) {
				if (listeners.length === 2) data[type] = listeners[i ? 0 : 1];
				else listeners.splice(i, 1);
			}
		}
	} else {
		if ((listeners === listener) ||
				(listeners.__eeOnceListener__ === listener)) {
			delete data[type];
		}
	}

	return this;
};

emit = function (type) {
	var i, l, listener, listeners, args;

	if (!hasOwnProperty.call(this, '__ee__')) return;
	listeners = this.__ee__[type];
	if (!listeners) return;

	if (typeof listeners === 'object') {
		l = arguments.length;
		args = new Array(l - 1);
		for (i = 1; i < l; ++i) args[i - 1] = arguments[i];

		listeners = listeners.slice();
		for (i = 0; (listener = listeners[i]); ++i) {
			apply.call(listener, this, args);
		}
	} else {
		switch (arguments.length) {
		case 1:
			call.call(listeners, this);
			break;
		case 2:
			call.call(listeners, this, arguments[1]);
			break;
		case 3:
			call.call(listeners, this, arguments[1], arguments[2]);
			break;
		default:
			l = arguments.length;
			args = new Array(l - 1);
			for (i = 1; i < l; ++i) {
				args[i - 1] = arguments[i];
			}
			apply.call(listeners, this, args);
		}
	}
};

methods = {
	on: on,
	once: once,
	off: off,
	emit: emit
};

descriptors = {
	on: d(on),
	once: d(once),
	off: d(off),
	emit: d(emit)
};

base = defineProperties({}, descriptors);

module.exports = exports = function (o) {
	return (o == null) ? create(base) : defineProperties(Object(o), descriptors);
};
exports.methods = methods;


/***/ }),

/***/ 1451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign        = __webpack_require__(1452)
  , normalizeOpts = __webpack_require__(1460)
  , isCallable    = __webpack_require__(1461)
  , contains      = __webpack_require__(1462)

  , d;

d = module.exports = function (dscr, value/*, options*/) {
	var c, e, w, options, desc;
	if ((arguments.length < 2) || (typeof dscr !== 'string')) {
		options = value;
		value = dscr;
		dscr = null;
	} else {
		options = arguments[2];
	}
	if (dscr == null) {
		c = w = true;
		e = false;
	} else {
		c = contains.call(dscr, 'c');
		e = contains.call(dscr, 'e');
		w = contains.call(dscr, 'w');
	}

	desc = { value: value, configurable: c, enumerable: e, writable: w };
	return !options ? desc : assign(normalizeOpts(options), desc);
};

d.gs = function (dscr, get, set/*, options*/) {
	var c, e, options, desc;
	if (typeof dscr !== 'string') {
		options = set;
		set = get;
		get = dscr;
		dscr = null;
	} else {
		options = arguments[3];
	}
	if (get == null) {
		get = undefined;
	} else if (!isCallable(get)) {
		options = get;
		get = set = undefined;
	} else if (set == null) {
		set = undefined;
	} else if (!isCallable(set)) {
		options = set;
		set = undefined;
	}
	if (dscr == null) {
		c = true;
		e = false;
	} else {
		c = contains.call(dscr, 'c');
		e = contains.call(dscr, 'e');
	}

	desc = { get: get, set: set, configurable: c, enumerable: e };
	return !options ? desc : assign(normalizeOpts(options), desc);
};


/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1453)()
	? Object.assign
	: __webpack_require__(1454);


/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	var assign = Object.assign, obj;
	if (typeof assign !== "function") return false;
	obj = { foo: "raz" };
	assign(obj, { bar: "dwa" }, { trzy: "trzy" });
	return (obj.foo + obj.bar + obj.trzy) === "razdwatrzy";
};


/***/ }),

/***/ 1454:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys  = __webpack_require__(1455)
  , value = __webpack_require__(1459)
  , max   = Math.max;

module.exports = function (dest, src /*, …srcn*/) {
	var error, i, length = max(arguments.length, 2), assign;
	dest = Object(value(dest));
	assign = function (key) {
		try {
			dest[key] = src[key];
		} catch (e) {
			if (!error) error = e;
		}
	};
	for (i = 1; i < length; ++i) {
		src = arguments[i];
		keys(src).forEach(assign);
	}
	if (error !== undefined) throw error;
	return dest;
};


/***/ }),

/***/ 1455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1456)()
	? Object.keys
	: __webpack_require__(1457);


/***/ }),

/***/ 1456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	try {
		Object.keys("primitive");
		return true;
	} catch (e) {
 return false;
}
};


/***/ }),

/***/ 1457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(940);

var keys = Object.keys;

module.exports = function (object) {
	return keys(isValue(object) ? Object(object) : object);
};


/***/ }),

/***/ 1458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// eslint-disable-next-line no-empty-function
module.exports = function () {};


/***/ }),

/***/ 1459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(940);

module.exports = function (value) {
	if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
	return value;
};


/***/ }),

/***/ 1460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(940);

var forEach = Array.prototype.forEach, create = Object.create;

var process = function (src, obj) {
	var key;
	for (key in src) obj[key] = src[key];
};

// eslint-disable-next-line no-unused-vars
module.exports = function (opts1 /*, …options*/) {
	var result = create(null);
	forEach.call(arguments, function (options) {
		if (!isValue(options)) return;
		process(Object(options), result);
	});
	return result;
};


/***/ }),

/***/ 1461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Deprecated



module.exports = function (obj) {
 return typeof obj === "function";
};


/***/ }),

/***/ 1462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1463)()
	? String.prototype.contains
	: __webpack_require__(1464);


/***/ }),

/***/ 1463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var str = "razdwatrzy";

module.exports = function () {
	if (typeof str.contains !== "function") return false;
	return (str.contains("dwa") === true) && (str.contains("foo") === false);
};


/***/ }),

/***/ 1464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var indexOf = String.prototype.indexOf;

module.exports = function (searchString/*, position*/) {
	return indexOf.call(this, searchString, arguments[1]) > -1;
};


/***/ }),

/***/ 1465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fn) {
	if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
	return fn;
};


/***/ }),

/***/ 1466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _events = __webpack_require__(939);

var _events2 = _interopRequireDefault(_events);

var _gusTips = __webpack_require__(1196);

var _gusTips2 = _interopRequireDefault(_gusTips);

var _howItWorks = __webpack_require__(1467);

var _howItWorks2 = _interopRequireDefault(_howItWorks);

var _modals = __webpack_require__(1199);

var _modals2 = _interopRequireDefault(_modals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init() {
  var btn = _jquery2.default.fn.button.noConflict(); // reverts $.fn.button to jqueryui btn
  _jquery2.default.fn.btn = btn; // assigns bootstrap button functionality to $.fn.btn
  (0, _jquery2.default)('.rover-btn').btn();

  // Enable button toggling functionality for rover buttons. Bootstrap hardcodes
  // their listener on .btn, so we have to do the same for .rover-btn
  (0, _jquery2.default)(document).on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
    var $roverBtn = (0, _jquery2.default)(e.target);

    // Account for the case when the click event occurred on something
    // inside the rover button
    if (!$roverBtn.hasClass('rover-btn')) {
      $roverBtn = $roverBtn.closest('.rover-btn');
    }

    $roverBtn.btn('toggle');
    e.preventDefault();
  });

  (0, _jquery2.default)('.js-gus-tip-dismiss').on('click', _gusTips2.default.handleGusTipDismiss);
  (0, _jquery2.default)('.js-show-modal').on('click', _modals2.default.showModal);
  (0, _jquery2.default)('.js-disable-click').on('click', disableClick);

  (0, _jquery2.default)(document).on('click', '.js-datepicker-calendar-trigger', handleCalendarButtonClick);
  (0, _jquery2.default)(document).on('click', '.js-timepicker-clock-trigger', handleClockButtonClick);
  (0, _jquery2.default)(document).on('click', '.js-clickable-for-radio', selectRadio);
  (0, _jquery2.default)(document).on('click', '.js-how-it-works .close, .js-how-it-works-trigger', _howItWorks2.default.toggle);
  (0, _jquery2.default)(document).on('click', '[data-record-click-event]', _events2.default.recordClickEventHandler);
}

function disableClick() {
  return false;
}

function selectRadio() {
  (0, _jquery2.default)(this).find('input[type="radio"]:not(:disabled)').prop('checked', true);
}

function handleClockButtonClick(e) {
  e.preventDefault();
  var $this = (0, _jquery2.default)(this);
  var $trigger_target = (0, _jquery2.default)($this.attr('data-trigger-target'));
  if (!$trigger_target.length) {
    $trigger_target = $this.find('.js-timepicker');
  }
  $trigger_target.focus();
  $trigger_target.timepicker('show');
}

function handleCalendarButtonClick(e) {
  e.preventDefault();
  var $this = (0, _jquery2.default)(this);
  var $trigger_target = (0, _jquery2.default)($this.attr('data-trigger-target'));
  if (!$trigger_target.length) {
    $trigger_target = $this.find('.js-date-picker');
  }
  $trigger_target.datepicker('show');
}

exports.default = {
  init: init,
  disableClick: disableClick,
  handleClockButtonClick: handleClockButtonClick,
  handleCalendarButtonClick: handleCalendarButtonClick
};

/***/ }),

/***/ 1467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Rover = __webpack_require__(7);

var _Rover2 = _interopRequireDefault(_Rover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toggle() {
  _Rover2.default.views.HeaderNavBarView.hideAllServices();

  if ($('.js-how-it-works').hasClass('in')) {
    $('.js-how-it-works').removeClass('in');
  } else {
    $('.js-how-it-works').addClass('in');
    $('html, body').animate({
      scrollTop: 0
    }, 400);
  }
}

exports.default = {
  toggle: toggle
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),

/***/ 1468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _Rover = __webpack_require__(7);

var _Rover2 = _interopRequireDefault(_Rover);

var _Mustache = __webpack_require__(73);

var _Mustache2 = _interopRequireDefault(_Mustache);

var _gallery_modal = __webpack_require__(682);

var _gallery_modal2 = _interopRequireDefault(_gallery_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializeGalleries() {
  var slides = [];
  var images = (0, _jquery2.default)('.js-shareable-image');
  var template = _Mustache2.default.template('new_design/social/modal_sharing_buttons');

  images.each(function (i, image) {
    var $image = (0, _jquery2.default)(image);

    var shareButtons = template.render({
      imageToShare: $image.attr('data-image-to-share'),
      imageThumbnail: $image.attr('data-image-thumbnail'),
      urlToShare: $image.attr('data-url-to-share'),
      contentType: $image.attr('data-content-type'),
      objectId: $image.attr('data-object-id'),
      campaign: $image.attr('data-campaign'),
      trackingContent: $image.attr('data-tracking-content'),
      caption: $image.attr('data-caption'),
      shareLocation: $image.attr('data-share-location'),
      hideable: $image.attr('data-hideable') === 'true',
      hidden: $image.attr('data-hidden') === 'true'
    });

    var slide = {
      type: 'image',
      src: $image.attr('href'),
      unsafeHtmlCaption: shareButtons
    };

    slides.push(slide);
  });

  var staysGalleryModal = new _gallery_modal2.default({
    classes: 'stays-gallery-modal',
    slides: slides
  });

  images.each(function (i, image) {
    var $image = (0, _jquery2.default)(image);

    (function (val) {
      $image.off('click').on('click', function (e) {
        e.preventDefault();
        if (staysGalleryModal) staysGalleryModal.openTo(val);
      });
    })(i);
  });
}

function init() {
  initializeGalleries();
}

exports.default = {
  init: init,
  initializeGalleries: initializeGalleries
};

/***/ }),

/***/ 1469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var showFailure = function showFailure() {
  (0, _jquery2.default)('.js-email-capture-footer-form-failure').fadeIn('fast');
};

var showThanks = function showThanks(response) {
  if (response.status !== 'success') {
    showFailure();
    return;
  }

  (0, _jquery2.default)('.js-email-capture-footer-form-failure').fadeOut('fast');
  (0, _jquery2.default)('.js-email-capture-footer-form-initial').fadeOut('fast', function () {
    (0, _jquery2.default)('.js-email-capture-footer-form-thanks').fadeIn('fast');
  });
};

var initializeEmailCaptureForm = function initializeEmailCaptureForm() {
  (0, _jquery2.default)('.js-email-capture-form').ajaxForm({
    success: showThanks
  });
};

var init = function init() {
  initializeEmailCaptureForm();
};

exports.default = {
  init: init
};

/***/ }),

/***/ 1470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _device = __webpack_require__(328);

var _deeplink = __webpack_require__(941);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _Rover = __webpack_require__(7);

var _Rover2 = _interopRequireDefault(_Rover);

var _userAgent = __webpack_require__(115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  _createClass(_class, null, [{
    key: 'closeBanner',
    value: function closeBanner() {
      (0, _jquery2.default)('.js-app-banner').addClass('hidden');
      (0, _jquery2.default)('body').removeClass('has-banner');
      _jquery2.default.cookie('appBanner', true, { expires: 90 });
    }
  }, {
    key: 'isPossibleBanner',
    value: function isPossibleBanner() {
      if (!_jquery2.default.cookie('appBanner')) {
        return true;
      }
      return false;
    }
  }, {
    key: 'init',
    value: function init() {
      if (!(0, _device.isMobileBrowser)() || !this.isPossibleBanner() || (0, _userAgent.isMobileEmbedded)() || (0, _jquery2.default)('body').hasClass('no-banner') || !_Rover2.default.context.supportsMobileApp) {
        return;
      }

      var appInstallBannerShownEvent = {
        event: 'navigation-app-install-banner-shown',
        nonInteractive: true
      };

      if (_Rover2.default.context.appInstallBannerUpdates) {
        appInstallBannerShownEvent.treatment = 'variant';
        _Rover2.default.context.iOSReviewCount = '76.8k+ Reviews';
        _Rover2.default.context.androidReviewCount = '4,300+ Reviews';
      } else {
        appInstallBannerShownEvent.treatment = 'control';
        _Rover2.default.context.iOSReviewCount = '2,140+ Reviews';
        _Rover2.default.context.androidReviewCount = '2,300+ Reviews';
      }

      dataLayer.push(_extends({}, appInstallBannerShownEvent));

      var routeURL = (0, _deeplink.getRouteURL)();

      (0, _jquery2.default)('body').addClass('has-banner');
      (0, _jquery2.default)('.js-app-banner').removeClass('hidden');
      (0, _jquery2.default)('.js-app-install-link').attr('href', routeURL);
      (0, _jquery2.default)('.js-close-app-banner').on('click', this.closeBanner);
      if ((0, _userAgent.isAndroid)()) {
        (0, _jquery2.default)('.js-review-count').text(_Rover2.default.context.androidReviewCount);
      } else {
        (0, _jquery2.default)('.js-review-count').text(_Rover2.default.context.iOSReviewCount);
      }
    }
  }]);

  return _class;
}();

exports.default = _class;

/***/ }),

/***/ 1472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _device = __webpack_require__(328);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ZendeskHelp = function () {
  function ZendeskHelp() {
    _classCallCheck(this, ZendeskHelp);
  }

  _createClass(ZendeskHelp, null, [{
    key: 'init',
    value: function init() {
      (0, _jquery2.default)('.js-help-button').on('click', this.onHelpButton.bind(this));
    }
  }, {
    key: 'initZendesk',
    value: function initZendesk() {
      if (!(0, _device.isMobileBrowser)()) {
        window.zEmbed || function (e, t) {
          var n = void 0,
              o = void 0,
              d = void 0,
              i = void 0,
              s = void 0,
              a = [],
              r = document.createElement('iframe');
          window.zEmbed = function () {
            a.push(arguments);
          }, window.zE = window.zE || window.zEmbed, r.src = 'javascript:false', r.title = '', r.role = 'presentation', (r.frameElement || r).style.cssText = 'display: none', d = document.getElementsByTagName('script'), d = d[d.length - 1], d.parentNode.insertBefore(r, d), i = r.contentWindow, s = i.document;

          try {
            o = s;
          } catch (c) {
            n = document.domain, r.src = 'javascript:var d=document.open();d.domain="' + n + '";void(0);', o = s;
          }
          o.open()._l = function () {
            var o = this.createElement('script');
            n && (this.domain = n), o.id = 'js-iframe-async', o.src = e, this.t = +new Date(), this.zendeskHost = t, this.zEQueue = a, this.body.appendChild(o);
          }, o.write('<body onload="document._l();">'), o.close();
        }('//assets.zendesk.com/embeddable_framework/main.js', 'rover.zendesk.com');
      }
    }
  }, {
    key: 'activateDesk',
    value: function activateDesk() {
      if (typeof window.zE.activate === 'function') {
        window.zE.activate();
      } else {
        window.setTimeout(this.activateDesk.bind(this), 500);
      }
    }
  }, {
    key: 'onHelpButton',
    value: function onHelpButton() {
      (0, _jquery2.default)('.js-help-button').hide();
      this.initZendesk();
      this.activateDesk();
    }
  }]);

  return ZendeskHelp;
}();

exports.default = ZendeskHelp;

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(22);

var _underscore2 = _interopRequireDefault(_underscore);

var _Mustache = __webpack_require__(73);

var _Mustache2 = _interopRequireDefault(_Mustache);

var _dataLayer = __webpack_require__(88);

var _dataLayer2 = _interopRequireDefault(_dataLayer);

var _Rover = __webpack_require__(7);

var _Rover2 = _interopRequireDefault(_Rover);

var _rover_modal = __webpack_require__(228);

var _rover_modal2 = _interopRequireDefault(_rover_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A photo gallery modal built using a royal slider(http://dimsemenov.com/plugins/royal-slider/documentation/)
 * inside of a chromeless Bootstrap modal (see .rover-media-modal)
 *
 * Example usage:
 *
 * import GalleryModalView from 'gallery_modal';
 *
 * const gallery = new GalleryModalView({
 *     slides: [
 *         { type: "image", src: "something.jpg", caption: "A photo of something" },
 *         { type: "image", src: "something2.jpg", caption: "Another photo of something" }
 *     ]
 * });
 *
 * // Open the gallery
 * gallery.open();
 *
 * // Open the gallery to 5th slide
 * gallery.openTo(4)
 *
 */
exports.default = _rover_modal2.default.extend({
  slideTemplates: {
    image: _Mustache2.default.template('new_design/common/media_gallery/image'),
    video: _Mustache2.default.template('new_design/common/media_gallery/video')
  },
  defaults: {
    classes: '',
    slides: []
  },
  initialize: function initialize(options) {
    this.options = _underscore2.default.extend({}, this.defaults, options);
    this.options.classes += ' rover-media-modal';
    // Since this modal is full-screen, we don't want scrollfixes
    this.options.applyScrollFix = false;
    _rover_modal2.default.prototype.initialize.call(this, this.options);
  },
  render: function render() {
    _rover_modal2.default.prototype.render.call(this);
    this.$modalContent.addClass('rover-media-gallery royalSlider');

    // Build up gallery markup
    var markup = this.getGalleryMarkup(this.options.slides);

    // Inject markup into modal
    this.setContent(markup);

    // Instantiate slider
    this.royalSlider = this.$modalContent.royalSlider({
      autoScaleSlider: false,
      controlNavigation: 'none',
      globalCaption: true,
      keyboardNavEnabled: true,
      numImagesToPreload: 2
    }).data('royalSlider');

    if (this.royalSlider) {
      this.initVideoSupport();
    }
  },

  // Adapted from http://help.dimsemenov.com/kb/royalslider-javascript-api/adding-support-for-third-party-video-player
  initVideoSupport: function initVideoSupport() {
    var _this = this;

    var slider = this.royalSlider;
    var videoPlayer = void 0;

    slider.ev.on('rsOnCreateVideoElement', function (e, videoSrc) {
      slider.videoObj = (0, _jquery2.default)('<div class="rsVideoObj"></div>');
      _underscore2.default.defer(function () {
        var currSlide = e.target.currSlide;
        var h = currSlide.iH;
        var w = currSlide.iW;
        var backupSrc = currSlide.content.data('video-backup-src');

        videoPlayer = _Rover2.default.video.player({
          container: slider.videoObj,
          width: '100%',
          aspectRatio: w + ':' + h,
          autoPlay: true
        });

        videoPlayer.load(videoSrc, backupSrc);
      });
    });

    slider.ev.on('rsOnDestroyVideoElement', function (e) {
      videoPlayer.remove();
    });
    slider.ev.on('rsAfterSlideChange', function (e) {
      _this.recordViewEvent();
    });
  },
  recordViewEvent: function recordViewEvent() {
    var eventName = this.options.recordedEvent;
    if (!eventName) {
      return;
    }
    var slide = this.options.slides[this.royalSlider.currSlideId];
    var opk = slide ? slide.opk : '';
    _dataLayer2.default.push({
      event: eventName,
      imageId: opk,
      providerId: _Rover2.default.context.providerId
    });
  },
  onModalShown: function onModalShown() {
    this.royalSlider.updateSliderSize();
    _rover_modal2.default.prototype.onModalShown.call(this);
    this.recordViewEvent();
  },
  openTo: function openTo(index) {
    this.royalSlider.goTo(index);
    this.open();
  },
  getSlideMarkup: function getSlideMarkup(slide) {
    return this.slideTemplates[slide.type].render(slide);
  },
  getGalleryMarkup: function getGalleryMarkup(slides) {
    var _this2 = this;

    var markup = '';

    _underscore2.default.each(slides, function (slide) {
      markup += _this2.getSlideMarkup(slide);
    });

    return markup;
  }
});

/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _undefined = __webpack_require__(1458)(); // Support ES3 engines

module.exports = function (val) {
 return (val !== _undefined) && (val !== null);
};


/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRouteURL = undefined;

var _Rover = __webpack_require__(7);

var _Rover2 = _interopRequireDefault(_Rover);

var _alooma = __webpack_require__(1198);

var _alooma2 = _interopRequireDefault(_alooma);

var _url = __webpack_require__(145);

var _cookie = __webpack_require__(627);

var _injector = __webpack_require__(23);

var _injector2 = _interopRequireDefault(_injector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getRouteURL = exports.getRouteURL = function getRouteURL() {
  var deeplink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rover://campaign/';

  var shouldIncludeMobileNativePushParam = (0, _injector2.default)('Rover.context.shouldIncludeMobileNativePushParam', false);

  var deepLinkWithParams = deeplink; // eslint-disable-line

  if (_Rover2.default.deeplink) {
    deepLinkWithParams = _Rover2.default.deeplink;
  }

  // append Mobile Native Push UTM Params
  if (shouldIncludeMobileNativePushParam) {
    _Rover2.default.UTMParameters = {
      utm_source: 'app_install_banner',
      utm_medium: 'web',
      utm_campaign: 'quick_match_landing_20180102'
    };
  }

  // append utm parameters if they exist
  if (_Rover2.default.UTMParameters) {
    deepLinkWithParams = (0, _url.appendUrlParams)(deepLinkWithParams, _Rover2.default.UTMParameters);
  }

  if (_Rover2.default.firstHttpReferrer) {
    deepLinkWithParams = (0, _url.appendUrlParams)(deepLinkWithParams, {
      http_referrer: encodeURIComponent(_Rover2.default.firstHttpReferrer)
    });
  }

  // append Ambassador params if they exist
  var ambassadorMbsyCode = (0, _url.getUrlParameter)('mbsy');
  if (ambassadorMbsyCode) {
    var extraAmbassadorParams = {
      mbsy: ambassadorMbsyCode,
      campaignid: (0, _url.getUrlParameter)('campaignid') || ''
    };
    ['promo_code', 'utm_source', 'utm_content'].map(function (name) {
      var value = (0, _url.getUrlParameter)(name);
      if (value) {
        extraAmbassadorParams[name] = value;
      }
    });
    deepLinkWithParams = (0, _url.appendUrlParams)(deepLinkWithParams, extraAmbassadorParams);
  }

  // append rover_cid
  var roverCid = (0, _cookie.getCookie)('rover_cid');
  if (roverCid) {
    deepLinkWithParams = (0, _url.appendUrlParams)(deepLinkWithParams, { rover_cid: roverCid });
  }

  // Append alooma distinct_id to branch
  var aloomaCookie = (0, _cookie.getCookie)('mp_rover_alooma');
  if (aloomaCookie) {
    var aloomaDistinctId = JSON.parse(decodeURIComponent('' + aloomaCookie)).distinct_id;
    if (aloomaDistinctId) {
      deepLinkWithParams = (0, _url.appendUrlParams)(deepLinkWithParams, { distinct_id: aloomaDistinctId });
    }
  }

  // Deeplink needs the protocol removed
  var afterClickUrl = encodeURIComponent(window.location.href);
  var deeplinkPath = encodeURIComponent(deepLinkWithParams.split('rover://')[1]);
  var routeURL = (0, _url.appendUrlParams)('https://r.rover.com/a/' + _Rover2.default.context.branchKey, {
    $deeplink_path: deeplinkPath,
    $after_click_url: afterClickUrl
  });

  return routeURL;
};

/***/ })

},[1440]);


// WEBPACK FOOTER //
// application_js.55287f3d7b353296.js